export const SET_VCP_CONFIG = 'SET_VCP_CONFIG'
export const SET_CURRENT_TARGET = 'SET_CURRENT_TARGET'
export const SET_VCP_CONFIG_LOADED = 'SET_VCP_CONFIG_LOADED'
export const SET_VCP_HASH = 'SET_VCP_HASH'
